var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guoduDiv"},[_c('div',{staticClass:"guochangani4"},[_c('img',{staticClass:"ani guochang1_guodu",attrs:{"src":_vm.mode[0]}})])])}
var staticRenderFns = []

export { render, staticRenderFns }